export default __webpack_public_path__ + "static/media/service-wrapper.568a112e.svg";